import { useRef, useEffect } from 'react'

import { getFocusableElements } from 'peach/helpers/focus'

import LoadingContainer from '../Loading/LoadingContainer'
import Panels from '../Panels/Panels'

import BigModalContainer from './BigModalContainer/BigModalContainer'
import ModalActionsBar from './ModalActionsBar'
import ModalContents from './ModalContents'
import ModalTitleBar from './ModalTitleBar'

const focusFirstFocusableItem = (...nodes) => {
  for (const node of nodes) {
    const els = getFocusableElements(node)
    if (els[0]) {
      els[0].focus()
      return
    }
  }
}

const BigModal = (props) => {
  const {
    title,
    big,
    noPadding,
    children,

    onCancel,

    onSubmit,
    isSubmitting,
    sending,
    submitLabel,

    error,
    onClearError,

    isOpen,
    onClose,

    onToggleDebugger,
    debugValue,
    onDebugReset,
  } = props

  const modalRef = useRef()
  const contentsRef = useRef()

  useEffect(() => {
    const onTimeout = () => {
      focusFirstFocusableItem(contentsRef.current, modalRef.current)
    }
    const id = setTimeout(onTimeout, 100)
    return () => clearTimeout(id)
  }, [])

  const displayTitle = title || 'Edit'

  return (
    <BigModalContainer
      big={big || debugValue}
      isOpen={isOpen}
      onClose={onClose}
      ref={modalRef}
    >
      <Panels
        footer={
          <ModalActionsBar
            isSubmitting={isSubmitting}
            onCancel={onCancel || onClose}
            onSubmit={onSubmit}
            sending={isSubmitting || sending}
            submitLabel={submitLabel || title}
          />
        }
        header={
          <ModalTitleBar
            onClose={onClose}
            onDebugReset={onDebugReset}
            onToggleDebugger={onToggleDebugger}
            title={displayTitle}
          />
        }
        right={debugValue}
        rightWidth='40%'
      >
        <LoadingContainer
          loading={isSubmitting || sending}
          message='Submitting'
        >
          <ModalContents
            error={error}
            isSubmitting={isSubmitting}
            noPadding={noPadding}
            onClearError={onClearError}
            ref={contentsRef}
          >
            {children}
          </ModalContents>
        </LoadingContainer>
      </Panels>
    </BigModalContainer>
  )
}

export default BigModal
